export enum ModalType {
  withBackBtn = 'withBackBtn',
  withBackBtnAndTitle = 'withBackBtnAndTitle',
  withHeader = 'withHeader',
  withBackAndCloseBtn = 'withBackAndCloseBtn',
  menuModal = 'menuModal',
  modalCard = 'modalCard',
}
